module.exports = {"230704005":"双子河社区","230704006":"先锋社区","230704007":"滨水社区","230704008":"前进社区","230704009":"向阳社区","230704010":"保安社区","230704011":"铁兴社区","230704400":"三合经营所","230704401":"松园林场","230704402":"中心经营所","230704403":"永青经营所","230704404":"碧云经营所","230704405":"友谊经营所","230704406":"青杨经营所","230704407":"岭峰林场","230704408":"奋斗林场","230704409":"东卡林场","230704410":"鸡爪河林场","230704411":"绿源林场","230704412":"广川经营所","230704413":"朝阳经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230704.json
// module id = 832
// module chunks = 0